import React from "react";

class CourseSectionHeader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-8">
                        <h3 style={{paddingBottom: "5px"}}><u>{this.props.title}</u></h3>
                    </div>
                </div>
            </div>
        );
    }
}

CourseSectionHeader.propTypes = {};

export default CourseSectionHeader;
